export type SearchableValue = string | number | null | undefined;

/** Splits a search string into lower-cased terms separated by whitespace. */
export function toSearchTerms(search: string | null | undefined): string[] {
  return (search ?? '').trim().toLocaleLowerCase().split(/\s+/).filter(Boolean);
}

/**
 * True when every search term is contained in at least one of the values,
 * so "cool super" matches "super cool driver". An empty search matches everything.
 */
export function matchesSearch(
  search: string | null | undefined,
  values: readonly SearchableValue[],
): boolean {
  const terms = toSearchTerms(search);
  if (terms.length === 0) {
    return true;
  }

  const normalizedValues = values
    .filter((value) => value !== null && value !== undefined)
    .map((value) => String(value).toLocaleLowerCase());

  return terms.every((term) =>
    normalizedValues.some((value) => value.includes(term)),
  );
}
